import React, { useState } from "react";
import axios from "axios";
import { baseUrl } from "../data/baseURL";
import { useNavigate } from "react-router-dom";

const AuthPage = () => {
  const [isSignUp, setIsSignUp] = useState(false);
  const [formData, setFormData] = useState({
    phoneNumber: "",
    firstName: "",
    lastName: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const url = isSignUp ? `${baseUrl}/Auth/Register` : `${baseUrl}/Auth/login`;
    try {
      const response = await axios.post(url, formData);

      if (response.data.applicationCode === 0) {
        const token = response.data.data.token;
        localStorage.setItem("token", token);
        window.location.reload();
      } else window.alert(response.data.message);
      setLoading(false);
    } catch (error) {
      console.error("Error:", error);
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-blue-100">
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full">
        <h2 className="text-2xl font-bold mb-6 text-blue-600">
          {isSignUp ? "ثبت نام" : "ورود"}
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-gray-700">شماره همراه</label>
            <input
              type="text"
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded"
              required
            />
          </div>
          {isSignUp && (
            <>
              <div className="mb-4">
                <label className="block text-gray-700">نام</label>
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border rounded"
                  required
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700">نام خانوادگی</label>
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border rounded"
                  required
                />
              </div>
            </>
          )}
          <div className="mb-4">
            <label className="block text-gray-700">رمز عبور</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded"
              required
            />
          </div>
          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition duration-200"
            disabled={loading}
          >
            {loading ? "صبر کنید..." : isSignUp ? "ثبت نام" : "ورود"}
          </button>
        </form>
        <button
          onClick={() => setIsSignUp(!isSignUp)}
          className="mt-4 text-blue-600 hover:underline"
        >
          {isSignUp
            ? "حساب کاربری دارید؟ وارد شوید"
            : "حساب کاربری ندارید؟ ثبت نام کنید"}
        </button>
      </div>
    </div>
  );
};

export default AuthPage;
